var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',{staticClass:"h-100 no-shadow border-dark"},[_c('CCardHeader',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.navigate}},[_vm._v(_vm._s(_vm.title))]),_c('CCardBody',[_vm._v(_vm._s(_vm.description))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }